/* eslint-disable no-undef */
import store from '@/store/store.js'


//Menu service used for managing  menus
export default {
  appointment: {},

  // Body of prescription
  pdfContent: [],

  //PDF document definition
  dd: {},

  //Short name for medicine type
  getShortname(dosageName) {
    if (dosageName) {
      dosageName = dosageName.substr(0, 3)
      return dosageName;
    }
  },

  //Check for ECG image in files array //Returns hasEcgFlag:boolean; fileId:String
  hasEcgFile(files) {
    var hasECG = false;
    var fileId;

    //Traverse the file array
    files.forEach(function (file) {
      if (file.name.indexOf('Device-ECG') > -1 && file.type.indexOf('image') > -1) {
        hasECG = true;
        fileId = file.fileId;
      }
    });

    if (hasECG)
      return {
        hasECG: true,
        fileId: fileId
      };
    else
      return {
        hasECG: false,
        fileId: fileId
      };
  },

  //Generate prescription using appointment object
  async makePrescription(appointment, prescription, prescriptionDate, options, cb) {
    var _this = this
    var _option = options;
    appointment = appointment;
    this.pdfContent = [{
      "columns": [{
        "text": [{
          "text": "MRN" + ": " + appointment.patient.patientId,
        },
        {
          "text": "\n" + "NAME" + ": " + appointment.patient.firstName + ' ' + appointment.patient.lastName,
        },
        {
          "text": "\n" + "AGE" + ": " + (() => {
            var m = moment(appointment.patient.dob);
            var years = moment().diff(m, "years", false);
            var months = moment().diff(m.add(years, "years"), "months", false);
            return years + " years, " + months + " months";
          })(),
        },
        {
          "text": "\n" + "GENDER" + ": " + (appointment.patient.gender).charAt(0).toUpperCase() + (appointment.patient.gender).substr(1).toLowerCase(),
        }
        ]
      },
      {
        "text": ""
      },
      {
        "text": [{
          "text": "DATE" + ": " + moment(prescriptionDate ? new Date(prescriptionDate) : new Date()).format('DD-MM-YYYY')
        },
        {
          "text": "\n" + "CONSULTANT" + ": Dr. " + appointment.provider.firstName + " " + appointment.provider.lastName
        }, {
          "text": "\n" + "SPECIALITY" + ": " + appointment.provider.specialityText,
        },
        {
          "text": appointment.provider.description ? ("\n" + "QUALIFICATION" + ": " + appointment.provider.description) : "",
        },
        {
          "text": appointment.provider.UIN ? ("\n" + "REG NO/UIN" + ": " + appointment.provider.UIN) : "",
        }
        ],


      }
      ],
      "style": "font-sm"
    }];

    //Update vitals
    if (appointment.vitals) {
      let hasVitals
      //Check for empty vitals
      for (var vital in appointment.vitals) {
        if (appointment.vitals[vital].value == "--" || appointment.vitals[vital].value.indexOf('image') > -1 || appointment.vitals[vital].value == "") {
          hasVitals = false;
        } else {
          hasVitals = true;
          break;
        }
      }

      if (hasVitals) {
        this.pdfContent.push({
          "text": "Diagnostic Summary" + " \t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t",
          "style": "sub-header",
        });

        var col = {
          "columns": [],
          "style": ["inner", "font-sm"]
        }

        for (var _vital in appointment.vitals) {

          if (appointment.vitals[_vital].value && appointment.vitals[_vital].value != "--" && _vital !== "ecg") {
            var vital = {
              "text": [
                // {
                //     "text": _vital
                // },
                {
                  "text": "\n" + appointment.vitals[_vital].name
                },
                {
                  "text": "\n" + appointment.vitals[_vital].value
                },
                {
                  "text": "\n" + appointment.vitals[_vital].unit
                }
              ]
            };

            col.columns.push(vital);
          }
        }

        this.pdfContent.push(col);
      }
    }

    //Update lab reports
    if (appointment.labReports && appointment.labReports.length > 0) {
      this.pdfContent.push({
        "text": "Lab Report" + " \t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t",
        "style": "sub-header"
      });

      //Lab device name
      labDevices.forEach(function (device, index) {

        if ($("#" + options.type + ' [id="' + device.name + '"] .reports').not('.ng-hide').length != 0) {

          this.pdfContent.push({
            "text": device.name,
            "style": ["highlight", index == 0 ? "inner" : "inner-top-break"]
          });

          //Table headers
          this.pdfContent.push({
            "columns": [{
              "text": "Investigation",
              "bold": true
            },
            {
              "text": "Value",
              "bold": true
            },
            {
              "text": "Range",
              "bold": true
            }
            ],
            "style": "inner-most-bottom-break"
          });

          //Value and unit
          device.parameters.forEach(function (param) {
            appointment.labReports.forEach(function (report) {

              //Parameter name
              if (report.Type == param.identifier && report.Provider == device.model && report.Value) {
                this.pdfContent.push({
                  "columns": [{
                    "text": param.name
                  },
                  {
                    "text": report.Value + "  " + param.unit,
                    "style": (report.Value < param.normalRange.from || report.Value > param.normalRange.to) ? "orange" : "green"
                  },
                  {
                    "columns": [{
                      "text": param.normalRange.from
                    },
                    {
                      "text": " - "
                    },
                    {
                      "text": param.normalRange.to
                    }
                    ]
                  }
                  ],
                  "style": ["inner-most", "font-sm"]
                });
              }
            });
          });
        }
      });
    }

    //Update descriptive notes
    if (prescription.descriptiveNotes) {
      this.pdfContent.push({
        "text": "Descriptive Notes" + " \t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t",
        "style": "sub-header"
      });
      this.pdfContent.push({
        "text": prescription.descriptiveNotes,
        "style": ["inner", "font-sm"]
      });
    }

    //Update Chief Complaints
    if (prescription.chiefComplaints) {
      this.pdfContent.push({
        "text": "Chief Complaints" + " \t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t",
        "style": "sub-header"
      });
      this.pdfContent.push({
        "text": prescription.chiefComplaints,
        "style": ["inner", "font-sm"]
      });
    }

    //Update Relevant Points from History
    if (prescription.relevantPointsfromHistory) {
      this.pdfContent.push({
        "text": "Relevant Points from History" + " \t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t",
        "style": "sub-header"
      });
      this.pdfContent.push({
        "text": prescription.relevantPointsfromHistory,
        "style": ["inner", "font-sm"]
      });
    }

    //Update Examination/Lab Findings
    if (prescription.labFindings) {
      this.pdfContent.push({
        "text": "Examination/Lab Findings" + " \t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t",
        "style": "sub-header"
      });
      this.pdfContent.push({
        "text": prescription.labFindings,
        "style": ["inner", "font-sm"]
      });
    }

    //Update provisional diagnosis
    if (prescription.provisionalDiagnosis && (prescription.provisionalDiagnosis.notes || prescription.provisionalDiagnosis.icdCodes.length > 0)) {
      _this.pdfContent.push({
        "text": "Provisional Diagnosis" + " \t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t",
        "style": "sub-header"
      });

      //Update notes
      if (prescription.provisionalDiagnosis.notes) {
        _this.pdfContent.push({
          "text": "Notes" + ":  " + prescription.provisionalDiagnosis.notes,
          "style": ["inner", "font-sm"]
        });
      }

      //Update icd codes
      if (prescription.provisionalDiagnosis.icdCodes.length > 0) {
        _this.pdfContent.push({
          "text": "ICD Codes" + ":  ",
          "margin": [20, 20, 0, 0],
          "style": "font-sm"
        });

        var icdList = [];
        prescription.provisionalDiagnosis.icdCodes.forEach(function (icd) {
          icdList.push(icd.Code + " - " + icd.Description);
        });
        _this.pdfContent.push({
          "ul": icdList,
          "margin": [40, 6, 0, 0],
          "style": "font-sm"
        });
      }
    }

    //Update SOAP notes
    if (prescription.soapNotes && (prescription.soapNotes.subjective || prescription.soapNotes.objective || prescription.soapNotes.assessment || prescription.soapNotes.plan)) {

      this.pdfContent.push({
        "text": "SOAP Notes" + " \t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t",
        "style": "sub-header"
      }, {
        "columns": [{
          "text": "Subjective" + ": " + (prescription.soapNotes.subjective ? prescription.soapNotes.subjective : " ")
        },
        {
          "text": "Objective" + ": " + (prescription.soapNotes.objective ? prescription.soapNotes.objective : " ")
        }
        ],
        "style": ["font-sm", "inner-bottom-sm-break"]
      }, {
        "columns": [{
          "text": "Assessment" + ": " + (prescription.soapNotes.assessment ? prescription.soapNotes.assessment : " ")
        },
        {
          "text": "Plan" + ": " + (prescription.soapNotes.plan ? prescription.soapNotes.plan : " ")
        }
        ],
        "style": ["font-sm", "inner"]
      });
    }

    //Update rx precsription
    if (prescription.rx && this.filterRx(prescription.rx).length > 0) {
      this.pdfContent.push({
        "text": "Rx Prescription" + " \t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t",
        "style": "sub-header"
      });

      prescription.rx.forEach(function (drug) {

        //Append drug name
        _this.pdfContent.push({
          "text": (_this.getShortname(drug.dosageForm) ? _this.getShortname(drug.dosageForm) : "") + " - " + drug.name,
          "style": ["inner", "highlight"]
        });

        //Add additional drug and frequency details
        _this.pdfContent.push({
          "columns": [{
            "text": drug.routeOfAdministration || '-'
          },
          {
            "text": drug.instruction || '-'
          },
          {
            "text": drug.frequency ? ((drug.frequency.durationNo || drug.frequency.duration == 'Till Next Visit') ? ((drug.frequency.duration != 'Till Next Visit' && drug.frequency.duration) ? 'For ' + (drug.frequency.durationNo ? drug.frequency.durationNo + "  - " + drug.frequency.duration + " " : "") : drug.frequency.duration) : "") + (drug.frequency.day ? " " + drug.frequency.day : "") : ""
          },
          {
            "text": drug.frequency && drug.frequency.when ? ((drug.frequency.minutes ? drug.frequency.minutes + " Mins " : "") + (drug.frequency.when ? "- " + drug.frequency.when : "")) : ""
          },
          {
            "columns": [{
              "text": drug.frequency ? "M" : "",
            },
            {
              "text": drug.frequency ? "A" : "",
            },
            {
              "text": drug.frequency ? "E" : "",
            },
            {
              "text": drug.frequency ? "N" : "",
            }
            ]
          }
          ],
          "style": ["inner-top-break", "font-sm"]
        });

        _this.pdfContent.push({
          "columns": [{
            "text": ""
          },
          {
            "text": ""
          },
          {
            "text": ""
          },
          {
            "text": ""
          },
          {
            "columns": [{
              "table": {
                "body": [
                  [drug.frequency ? (drug.frequency.morning.nos ? (drug.frequency.morning.nos ? drug.frequency.morning.nos.toString() : "0") : "0") : " "]
                ]
              },
              "layout": {
                "hLineColor": !drug.frequency ? "white" : "",
                "vLineColor": !drug.frequency ? "white" : "",
              }
            },
            {
              "table": {
                "body": [
                  [drug.frequency ? (drug.frequency.afternoon.nos ? (drug.frequency.afternoon.nos ? drug.frequency.afternoon.nos.toString() : "0") : "0") : " "]
                ]
              },
              "layout": {
                "hLineColor": !drug.frequency ? "white" : "",
                "vLineColor": !drug.frequency ? "white" : "",
              }
            },
            {
              "table": {
                "body": [
                  [(drug.frequency && drug.frequency.evening) ? (drug.frequency.evening.nos ? (drug.frequency.evening.nos ? drug.frequency.evening.nos.toString() : "0") : "0") : " "]
                ]
              },
              "layout": {
                "hLineColor": !drug.frequency ? "white" : "",
                "vLineColor": !drug.frequency ? "white" : "",
              }
            },
            {
              "table": {
                "body": [
                  [drug.frequency ? (drug.frequency.night.nos ? (drug.frequency.night.nos ? drug.frequency.night.nos.toString() : "0") : "0") : " "]
                ]
              },
              "layout": {
                "hLineColor": !drug.frequency ? "white" : "",
                "vLineColor": !drug.frequency ? "white" : "",
              }
            }

            ]
          }
          ],
          "style": ["font-sm", "inner"]
        });
      });
    }

    //Update lab prescription
    if (prescription.labPrescription && this.filterLab(prescription.labPrescription).length > 0) {
      this.pdfContent.push({
        "text": "Lab Prescription" + " \t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t",
        "style": "sub-header"
      });

      prescription.labPrescription.forEach(function (labPres, index) {
        _this.pdfContent.push({
          "type": "square",
          "ul": [{
            "text": [{
              "text": labPres.test + " \n",
            },
            {
              "text": labPres.comment ? "- " + labPres.comment : "",
              "style": ["inner", "font-sm"]
            }
            ],
            "style": index != 0 ? "break" : ""
          }],
          "style": "inner"
        });
      });
    }

    //Update other comments
    if (prescription.otherComments) {
      _this.pdfContent.push({
        "text": "Other Comments" + " \t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t",
        "style": "sub-header"
      }, {
        "text": prescription.otherComments,
        "style": ["inner", "font-sm"]
      });
    }

    //Update referrals
    if (prescription.referrals && (prescription.referrals.to || prescription.referrals.hospital)) {
      _this.pdfContent.push({
        "text": "Referrals" + " \t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t",
        "style": "sub-header"
      }, {
        "text": [{
          "text": "Referred To:" + "  \t"
        },
        {
          "text": (prescription.referrals.provider && prescription.referrals.provider.fullName) ? ("Dr. " + prescription.referrals.provider.fullName) : ""
        },
        {
          "text": (prescription.referrals.provider && prescription.referrals.provider.specialityText) ? (", " + prescription.referrals.provider.specialityText) : ""
        },
        {
          "text": prescription.referrals.hospital ? " - " + prescription.referrals.hospital.name : ""
        },
        {
          "text": prescription.referrals.hospital ? ", " + prescription.referrals.hospital.address : ""
        },
        {
          "text": prescription.referrals.comments ? ("\n" + "Comments" + ":   \t") : ""
        },
        {
          "text": prescription.referrals.comments ? prescription.referrals.comments : ""
        }

        ],
        "style": ["inner", "font-sm"]
      });
    }

    //Update follow ups
    if (prescription.followup && prescription.followup.requested) {
      _this.pdfContent.push({
        "text": "Follow Up" + " \t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t",
        "style": "sub-header"
      })

      if (prescription.followup.followupDate) {
        _this.pdfContent.push({
          "text": [{
            "text": "On" + "\t" + new Date(prescription.followup.followupDate).toLocaleDateString('default', { month: 'short' }) + " " + new Date(prescription.followup.followupDate).getUTCDay() + ", " + new Date(prescription.followup.followupDate).getUTCFullYear()
          }],
          "style": ["inner", "font-sm"]
        })
      } else {
        _this.pdfContent.push({
          "text": [{
            "text": "After" + "\t" + (prescription.followup.durationNo || '   ') + " " + (prescription.followup.duration || '')
          }],
          "style": ["inner", "font-sm"]
        })
      }

      if (prescription.followup.comments) {
        _this.pdfContent.push({
          "text": [{
            "text": "Comments:" + "\t" + prescription.followup.comments
          }],
          "style": ["inner", "font-sm"]
        })
      }
    }

    //Update Emergency Care
    if (prescription.emergencyCare) {
      this.pdfContent.push({
        "text": "Emergency Care" + " \t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t",
        "style": "sub-header"
      });
      this.pdfContent.push({
        "text": prescription.emergencyCare,
        "style": ["inner", "font-sm"]
      });
    }

    //Update signature
    if (prescription.signature) {
      let provider = await store.dispatch('getUserById', appointment.provider.providerId)

      this.pdfContent.push({
        "image": await store.dispatch('getFileAsDataUrl', prescription.signature),
        "width": 200,
        "alignment": "right",
        "style": "break"
      }, {
        "text": "___________________________________\n" + 'Signature',
        "bold": true,
        "alignment": "right"
      }, {
        "text": 'Dr. ' + appointment.provider.firstName + ' ' + appointment.provider.lastName,
        "alignment": "right"
      }, {
        "text": provider.registration.number,
        "alignment": "right"
      });
    }


    //Update ECG image
    if (options && options.ecg) {

      //If historic, get ECG image from files array
      if (_option.type == "historicPrescription") {

        if (appointment.files && appointment.files.length > 0) {

          var hasEcgImage = false;
          var resp = hasEcgFile(appointment.files);

          if (resp.hasECG) {

            hasEcgImage = true;
            //Get file from minio
            $http({
              method: 'GET',
              url: 'carenation-fileshare-service/file/' + resp.fileId,
              responseType: 'arraybuffer'
            })
              .success(async function (response) {

                //Convert to dataURL
                var uInt8Array = new Uint8Array(response);
                var i = uInt8Array.length;
                var biStr = new Array(i);
                while (i--) {
                  biStr[i] = String.fromCharCode(uInt8Array[i]);
                }
                var data = biStr.join('');
                var base64 = window.btoa(data);
                ecgImage = 'data:image/png;base64,' + base64;

                this.pdfContent.push({
                  "image": "ecgImage",
                  "width": 550,
                  "height": 650
                });

                await this.makeDocDefinition();

                //Trigger call back
                cb();
              })
              .error(async function (response) {
                await this.makeDocDefinition();

                //Trigger call back
                cb();
              });
          } else {
            console.log('No ecg file')
          }

          //If ECG image is not present
          if (!hasEcgImage) {
            await this.makeDocDefinition();
            cb();
          }
        } else {
          swal("ECG not found");
        }
      }
      //Else get ECG image from device service
      else {
        this.pdfContent.push({
          "image": "ecgImage",
          "width": 550,
          "height": 650
        });
        $http({
          method: 'GET',
          url: '/carenation-device-service/image-service/image/' + appointment.vitals['ecg'].value,
          responseType: 'arraybuffer'
        }).success(async function (response) {
          var uInt8Array = new Uint8Array(response);
          var i = uInt8Array.length;
          var biStr = new Array(i);
          while (i--) {
            biStr[i] = String.fromCharCode(uInt8Array[i]);
          }
          var data = biStr.join('');
          var base64 = window.btoa(data);
          ecgImage = 'data:image/png;base64,' + base64;

          await this.makeDocDefinition();

          //Trigger call back
          cb();
        }).error(function (response) {
          swal({
            title: 'Oops!',
            text: 'Error retrieving image from the server!',
            type: "error",
            timer: 5000
          });
        });
      }
    } else {
      await this.makeDocDefinition();
      console.log('doc definiton done')
      cb();
    }
  },

  //Generate PDF document definiton for prescription
  async makeDocDefinition() {
    let headerImage = null;
    let footerImage = null;
    if (store.state.settings.prescriptionHeaderImage) {
      headerImage = await store.dispatch('getFileAsDataUrl', store.state.settings.prescriptionHeaderImage)
    }
    if (store.state.settings.footerImage) {
      footerImage = await store.dispatch('getFileAsDataUrl', store.state.settings.footerImage)
    }

    this.dd = {
      "pageMargins": [
        25,
        120,
        25,
        120
      ],
      "header": {
        "image": "headerImage",
        "width": 600,
        "height": 100
      },
      "footer": {
        "image": "footerImage",
        "width": 600,
        "height": 100
      },
      "content": this.pdfContent,
      "images": {
        "headerImage": headerImage,
        "footerImage": footerImage
      },
      "styles": {
        "font-sm": {
          "fontSize": 9
        },
        "sub-header": {
          "fontSize": 12,
          "bold": false,
          "alignment": "justify",
          "margin": [0, 15],
          "color": "black",
          "background": "#EEE",
        },
        "break": {
          "margin": [0, 20]
        },
        "inner-top-break": {
          "margin": [20, 10, 0, 0]
        },
        "inner-most-bottom-break": {
          "margin": [40, 0, 0, 5]
        },
        "inner-bottom-sm-break": {
          "margin": [20, 0, 0, 5]
        },
        "inner-bottom-break": {
          "margin": [20, 0, 0, 10]
        },
        "small-break": {
          "margin": [0, 10]
        },
        "inner": {
          "margin": [20, 0, 0, 0]
        },
        "inner-most": {
          "margin": [40, 0, 0, 0]
        },
        "inner-n-small-break": {
          "margin": [20, 10, 0, 0]
        },
        "inner-most-n-small-break": {
          "margin": [40, 10, 0, 0]
        },
        "inner-n-break": {
          "margin": [20, 20, 0, 0]
        },
        "highlight": {
          "background": "#EEE"
        },
        "green": {
          "color": "#0c8412"
        },
        "orange": {
          "color": "orange"
        }
      },
      "defaultStyle": {
        "font": "english"
      }
    };
    if (!headerImage) {
      delete this.dd["header"]
    }
    if (!footerImage) {
      delete this.dd["footer"]
    }
  },

  //Returns dataURL of prescription (PDF)
  /*options: {
    ecg: boolean
    type: prescription div's ID
  }*/
  getDataURL(appointment, prescription, prescriptionDate, options, cb) {
    let that = this

    this.makePrescription(appointment, prescription, prescriptionDate, options, function () {
      var dataUrlHandle = pdfMake.createPdf(that.dd);

      dataUrlHandle.getDataUrl(function (data) {
        cb(data);
      });
    });
  },

  //Prints the prescription
  /*options: {
        ecg: boolean
        type: prescription div's ID
      }*/
  print(appointment, options, cb) {
    var _this = this
    this.makePrescription(appointment, options, function () {
      var pdfHandle = pdfMake.createPdf(_this.dd);
      pdfHandle.getBase64((base64) => {
        var options = {
          data: base64, // content, either base64 string or file uri (required)
          // (omit "data:application/pdf;base64," part from base64 string)

          type: 'Data', // type of content, use either 'Data' or 'File'

          title: 'Prescription', // title of document

          dialogX: -1, // if a dialog coord is not set, it defaults to -1.
          // the iOS method will fall back to center if it gets
          dialogY: -1, // a dialog coord less than 0. (iPad only)

          success: null, // success callback function, argument is a json string.
          // parsed json format:
          // {success: true}

          error: null // error callback function, argument is a json string.
          // parsed json format:
          // {success: [boolean], available: [boolean], error: [string], dismissed: [boolean]}

        };
        window.plugins.PrintPDF.print(options);
      });
    });
  },

  download(appointment, prescription, prescriptionDate, options, cb) {
    var _this = this
    this.makePrescription(appointment, prescription, prescriptionDate, options, function () {
      var pdfHandle = pdfMake.createPdf(_this.dd).download('Prescription')
      if (cb) {
        cb()
      }
    });
  },

  //Filter Rx
  filterRx(rxPres) {
    if (rxPres) {
      var rxArray = [];
      rxPres.forEach(function (_rx) {
        if (_rx.name != "") {
          rxArray.push(_rx);
        }
      });
      return rxArray;
    }
  },

  //Filter Lab Prescription
  filterLab(labPres) {
    if (labPres) {
      var labArray = [];
      labPres.forEach(function (_lab) {
        if (_lab.test != "") {
          labArray.push(_lab);
        }
      });
      return labArray;
    }
  },

  hasDietPlan(prescription) {
    if (prescription && prescription && prescription.dietPlan) {
      let dietPlan = prescription.dietPlan;

      if (dietPlan.type == "daily") {
        if (this.hasFoodOptionsForTheDay(dietPlan.dailyPlan)) {
          return true;
        } else {
          return false;
        }
      } else {
        let HAS_DIET_PLAN = false;
        for (var day in dietPlan.weeklyPlan) {
          if (this.hasFoodOptionsForTheDay(dietPlan.weeklyPlan[day])) {
            HAS_DIET_PLAN = true;
            break;
          }
        }
        return HAS_DIET_PLAN;
      }
    } else {
      return false;
    }
  },

  hasFoodOptionsForTheDay(dailyPlan) {
    return (
      dailyPlan.earlyMorning.foodOptions.length > 0 ||
      dailyPlan.bedTime.foodOptions.length > 0 ||
      dailyPlan.breakfast.foodOptions.length > 0 ||
      dailyPlan.dinner.foodOptions.length > 0 ||
      dailyPlan.evening.foodOptions.length > 0 ||
      dailyPlan.lunch.foodOptions.length > 0 ||
      dailyPlan.midMorning.foodOptions.length > 0
    );
  },

  hasPrescription(prescriptions) {
    return (
      prescriptions.privateNotes ||
      prescriptions.descriptiveNotes ||
      (prescriptions.provisionalDiagnosis && prescriptions.provisionalDiagnosis.notes) ||
      (prescriptions.provisionalDiagnosis && prescriptions.provisionalDiagnosis.icdCodes && prescriptions.provisionalDiagnosis.icdCodes.length > 0) ||
      (prescriptions.rx && prescriptions.rx.length > 0) ||
      (prescriptions.labPrescription && prescriptions.labPrescription.length > 0) ||
      prescriptions.otherComments ||
      prescriptions.chiefComplaints ||
      prescriptions.relevantPointsfromHistory ||
      prescriptions.labFindings ||
      prescriptions.emergencyCare ||
      (prescriptions.imagingPrescription &&
        prescriptions.imagingPrescription.types.length > 0) ||
      this.hasDietPlan(prescriptions) ||
      (prescriptions.followup && prescriptions.followup.requested)
    )
  }
}
